let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("69mwC")).then(() => parcelRequire('i7ntw'));